import React from 'react';
import swiper from 'swiper';
import Store from '../redux/store';
import 'swiper/swiper.min.css';
import '../resources/css/notice-page.css';
import i18n from '../i18n';
import { DefaultRequest } from '../requests/default.request';
import { PhotoSlider } from 'react-photo-view';
import { NoticeData } from '../constants/type.constant';
import { preLoadNginxImage } from '../tools/utils';

export default class NoticePage extends React.Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            // 公告图片
            notice: [],
            // 加载中
            loading: true,
            // 是否打开公告大图
            noticeDetailVisible: false,
            // 大图轮播图索引
            initialSlide: 0,
            // 活动公告
            activityBulletinData: [],
        }
    }

    // *********************
    // 生命周期
    // *********************
    public componentDidMount() {
        // 获取公告图片
        // this.getnoticeImg();

        // 活动公告
        this.getActivityBulletin();
    }


    // *********************
    // 方法区
    // *********************

    /**
     *  查询活动公告
     */
    public async getActivityBulletin() {
        let activityData: Array<NoticeData> = [];
        let url = Store.getState().serverUrl;
        try {
            const ACTIVITY_RES = await DefaultRequest.getActivityBulletin();
            if (Array.isArray(ACTIVITY_RES)) {
                const promises = ACTIVITY_RES.map(async (item) => {
                    const img = `${url}/bulletin/${item}`
                    const newImg = await preLoadNginxImage(img, '/bulletin', '');
                    return newImg
                })
                const imgList = await Promise.all(promises);
                imgList.forEach((item, index) => {
                    activityData.push({
                        alt: `bulletin${index}`,
                        src: item,
                        className: 'asdasd'
                    })
                })
                this.setState({ activityBulletinData: activityData }, () => {
                    if (activityData.length === 0 &&
                        this.props.activityBulletinCallBack) this.props.activityBulletinCallBack();
                    // 初始化轮播图
                    if (activityData.length > 0) {
                        new swiper('.swiper-container', {
                            pagination: {
                                el: '.swiper-pagination',
                            },
                        })
                    }
                });
            }
        } catch (error) { }
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { loading, activityBulletinData } = this.state;
        // const noticeSet: Array<{ src: string; alt: string }> = [];
        return (
            <React.Fragment>
                <div className="noticePage">
                    {
                        activityBulletinData.length === 0 && (!loading) ?
                            <div className="noData">
                                <div>{i18n.t('notice_page_text_no_picture')}</div>
                            </div>
                            :
                            <div className="swiper-container">
                                <div className="swiper-wrapper">
                                    {
                                        activityBulletinData.map((item, index) => (
                                            <div
                                                className="swiper-slide"
                                                key={index}
                                                onClick={() => {
                                                    // Zmage.browsing({
                                                    //     defaultPage: index,
                                                    //     set: activityBulletinData,
                                                    //     controller: {
                                                    //         // 旋转按钮
                                                    //         rotate: false,
                                                    //         // 翻页按钮
                                                    //         flip: true,
                                                    //         // 多页指示
                                                    //         pagination: true,
                                                    //     },
                                                    //     hideOnScroll: false,
                                                    //     // 预设
                                                    //     preset: 'mobile',
                                                    //     // 背景色
                                                    //     backdrop: "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%)"
                                                    // })
                                                    this.setState({
                                                        noticeDetailVisible: true,
                                                        initialSlide: index,
                                                    })
                                                }}
                                            >
                                                <div className="box" style={{ backgroundImage: `url(${item.src})` }} />
                                            </div>
                                        ))
                                    }
                                    <PhotoSlider
                                        images={activityBulletinData.map((item) => ({ src: item.src }))}
                                        visible={this.state.noticeDetailVisible}
                                        onClose={() => this.setState({ noticeDetailVisible: false })}
                                        index={this.state.initialSlide}
                                        onIndexChange={(index: any) => { this.setState({ initialSlide: index }) }}
                                    />
                                </div>
                            </div>

                    }
                </div>
                {/* 公告大图 */}
                {/* {
                    noticeDetailVisible &&
                    <NoticeDetailComponent
                        noticeDetailVisible={noticeDetailVisible}
                        noticeData={notice}
                        initialSlide={this.state.initialSlide}
                        closeNoticeDetail={() => {
                            this.setState({
                                noticeDetailVisible: false
                            })
                        }}
                    />
                } */}
            </React.Fragment>
        )
    }

}

// **********
// TYPE
// **********

type Props = {
    // 活动公告更新回调
    activityBulletinCallBack?: () => void;
};

type State = {
    // 公告图片
    notice: Array<Notice>;
    // 加载中
    loading: boolean;
    // 是否打开公告大图
    noticeDetailVisible: boolean;
    // 大图轮播图索引
    initialSlide: number;
    // 活动公告
    activityBulletinData: Array<NoticeData>;
}

// 公告图片
export type Notice = {
    id: number,
    src: string,
}